<template>
  <modal name="customWorksSubmitted"
    transition="nice-modal-fade"
    :pivotY="0.3"
    :classes="[]"
    @before-open="beforeOpen"
  >
    <div class="container">
      <div class="content">
        <span>需求提交成功,我们将在2个工作日内与您联系,<br>请确保您的手机号畅通</span>
      </div>
      <div class="footer">
        <div class="button button--primary" @click="hide()">返回继续创作</div>
      </div>
      <div class="close-btn" @click="hide()">
        <i class="icon-popup-close"></i>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  data () {
    return {

    }
  },
  methods: {
    hide () {
      this.$modal.hide('customWorksSubmitted');
    },
    beforeOpen () {

    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  position: relative;
  width: 420px;
  height: 210px;
  margin: auto;
  padding-top: 48px;
	background-color: #ffffff;
	box-shadow: 0px 0px 4px 0px
		rgba(54, 76, 204, 0.4);
	border-radius: 4px;
  text-align: center;
}

.content {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
  min-height: 44px;
  line-height: 1.5;
}

.footer {
  display: flex;
  align-items: center;
  justify-content: center;
}

.button {
    width: 160px;
    height: 40px;
    border-radius: 8px;
    color: #ffffff;
    text-align: center;
    line-height: 40px;
    cursor: pointer;
}

.close-btn {
  position: absolute;
  top: 14px;
  right: 14px;
  cursor: pointer;
}
</style>




// WEBPACK FOOTER //
// src/components/emodal/customWorksSubmitted.vue